import type { RoleKey, Permission } from '@/utils/rbac';

export interface StaffMember {
  id: string;
  name: string;
  email: string;
  password: string;
  roles: RoleKey[];            // ← 显示用角色标签
  permissions?: Permission[];  // ← 精确权限（优先于 roles 推导）
  status: 'active' | 'inactive';
  department: string;
  createdAt: string;
  lastLogin?: string;
}

export const staffMembers: StaffMember[] = [
  {
    id: 'staff_001',
    name: 'Admin',
    email: 'admin@gtraweb3.com',
    password: 'gtra2026',
    roles: ['super_admin'],
    status: 'active',
    department: '技术部',
    createdAt: '2025-01-01',
    lastLogin: '2026-04-01',
  },
  {
    id: 'staff_002',
    name: '李晓燕',
    email: 'xiaoyan@gtraweb3.com',
    password: 'gtra2026',
    roles: ['event_manager'],
    status: 'active',
    department: '活动运营部',
    createdAt: '2025-03-15',
    lastLogin: '2026-03-28',
  },
  {
    id: 'staff_003',
    name: '王浩然',
    email: 'haoran@gtraweb3.com',
    password: 'gtra2026',
    roles: ['content_manager', 'reviewer'],
    status: 'active',
    department: '内容运营部',
    createdAt: '2025-04-01',
    lastLogin: '2026-03-30',
  },
  {
    id: 'staff_004',
    name: '张敏',
    email: 'zhangmin@gtraweb3.com',
    password: 'gtra2026',
    roles: ['event_manager', 'reviewer'],
    status: 'active',
    department: '审核部',
    createdAt: '2025-06-01',
    lastLogin: '2026-03-25',
  },
  {
    id: 'staff_005',
    name: '陈思远',
    email: 'siyuan@gtraweb3.com',
    password: 'gtra2026',
    roles: ['viewer'],
    status: 'inactive',
    department: '市场部',
    createdAt: '2025-08-10',
  },
];
